import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Button,
  TextInput,
  LoadingIndicator,
  WideAlert,
  FModal,
  FLink,
  Icons,
} from '@components';
import { currency } from '@utils';
import { useSelector } from 'react-redux';
import { object, number } from 'yup';
import { Formik, Field } from 'formik';

import { useNavigate } from 'react-router-dom';
import {
  SaqueAVistaService,
  PercentualRecebimentoRendaService,
} from '@services';
import { parse, differenceInDays, format } from 'date-fns';
import {
  mdiAlertCircleOutline,
  mdiCheckCircleOutline,
  mdiCommentAlertOutline,
} from '@mdi/js';
import { MEMORIA_CALCULO } from '../../../common/utils/paths';

const InformacoesGerais = ({ apiSaqueAVista }) => {
  const diasRestantesReq = () => {
    if (apiSaqueAVista.DataLimiteParaSaque !== undefined) {
      const diasDiferenca = differenceInDays(
        parse(
          format(
            parse(apiSaqueAVista.DataLimiteParaSaque, 'yyyyMMdd', new Date()),
            'dd/MM/yyyy'
          ),
          'dd/MM/yyyy',
          new Date()
        ),
        new Date()
      );
      return diasDiferenca < 0 ? 0 : diasDiferenca;
    }
    return '';
  };

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-8 col-lg-4">
          <h4 className="ts-20 fw-bold  mb-2 text-orange">Tipo do Benefício</h4>
          <h1 className="ts-18 fw-bold text-muted mb-3">
            {apiSaqueAVista.Tipobenef}
          </h1>
        </div>
        <div className="col-12 col-md-8 col-lg-4">
          <h4 className="ts-20 fw-bold  mb-2 text-orange">
            Forma de Recebimento
          </h4>
          <h1 className="ts-18 fw-bold text-muted mb-3">
            {apiSaqueAVista.FormaRec}
          </h1>
        </div>
        <div className="col-12 col-md-8 col-lg-4">
          <h4 className="ts-20 fw-bold  mb-2 text-orange">Valor Saldo Atual</h4>
          <h1 className="ts-18 fw-bold text-muted mb-3">
            {currency(apiSaqueAVista.VrSldReman)}
          </h1>
        </div>
      </div>
      <div className="row mt-3 ">
        <div className="col-12 col-md-8 col-lg-4">
          <h4 className="ts-20 fw-bold  mb-2 text-orange">
            Data Início do Benefício (DIB)
          </h4>
          <h1 className="ts-18 fw-bold text-muted mb-3">
            {apiSaqueAVista.DataInicio !== undefined &&
              format(
                parse(apiSaqueAVista.DataInicio, 'yyyyMMdd', new Date()),
                'dd/MM/yyyy'
              )}
          </h1>
        </div>
        <div className="col-12 col-md-8 col-lg-4">
          <h4 className="ts-20 fw-bold  mb-2 text-orange">
            Dias restantes para requisição
          </h4>
          <h1 className="ts-18 fw-bold text-muted mb-3">
            {diasRestantesReq()}
          </h1>
        </div>
        <div className="col-12 col-md-8 col-lg-4">
          <h4 className="ts-20 fw-bold  mb-2 text-orange">
            Valor do Benefício Atual
          </h4>
          <h1 className="ts-18 fw-bold text-muted mb-3">
            {currency(
              (apiSaqueAVista.PercRenda / 100) * apiSaqueAVista.VrSldReman
            )}
          </h1>
        </div>
      </div>
      {apiSaqueAVista.CdConsistencia > 2 &&
        apiSaqueAVista.SolictStatusSol !== 'pago' && (
          <WideAlert className="mb-4 mt-32" iconClear={false}>
            <div className="d-block d-lg-flex align-items-center">
              <Icons
                path={mdiCommentAlertOutline}
                color="var(--primary-color)"
                size={2}
                style={{ marginRight: 4 }}
              />
              <p className="ts-16">
                <strong>Aviso importante:</strong>{' '}
                {apiSaqueAVista.MsgConsistencia}
              </p>
            </div>
          </WideAlert>
        )}
      {apiSaqueAVista.SolictStatusSol === 'pago' && (
        <WideAlert className="mb-4 mt-32" iconClear={false}>
          <div className="d-block d-lg-flex align-items-center">
            <Icons
              path={mdiCommentAlertOutline}
              color="var(--primary-color)"
              size={2}
              style={{ marginRight: 4 }}
            />
            <p className="ts-16">
              <strong>Aviso importante:</strong>
              {' O requerimento de saque à vista já foi pago'}
              <br />
              <FLink to={MEMORIA_CALCULO} className="mt-2">
                Acessar a tela de Memória de Cálculo de Benefício
              </FLink>
            </p>
          </div>
        </WideAlert>
      )}
    </>
  );
};

export const SaqueAVistaPage = () => {
  const navigate = useNavigate();
  const { matricula, plano } = useSelector((state) => state.user.data);
  const [rendaMinimaMensal, setRendaMinimaMensal] = useState('');
  const [percentualMaximo, setPercentualMaximo] = useState('');
  const [statusRegistro, setStatusRegistro] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [percentualRenda, setPercentualRenda] = useState(0);
  const [apiSaqueAVista, setApiSaqueAVista] = useState({});
  const [rendaSchema, setRendaSchema] = useState({});

  useEffect(() => {
    const recuperaInformacoesIniciais = async () => {
      setLoading(true);
      const saqueAVistaService = new SaqueAVistaService();
      const percentualRecebimentoRenda =
        new PercentualRecebimentoRendaService();

      const responseSaqueAVista = await saqueAVistaService.getSaqueAVista(
        matricula
      );
      setApiSaqueAVista({
        ...responseSaqueAVista,
        CdConsistencia: Number(responseSaqueAVista.CdConsistencia),
      });

      const responsePorcentagem =
        await saqueAVistaService.getLimitePorcentagemSaqueAVista(matricula);
      const valorPercentualRenda =
        await percentualRecebimentoRenda.getRecebimentoSaldoContas(
          matricula,
          plano
        );
      setPercentualRenda(Number(valorPercentualRenda.replace(',', '.')));

      setRendaSchema(
        object({
          percentualSaqueAVista: number()
            .required('O valor é obrigatório')
            .integer()
            .min(1, `Valor percentual mínimo deverá ser de ${1}`)
            .max(
              responsePorcentagem.slice(-1),
              `Valor percentual máximo deverá ser de ${responsePorcentagem.slice(
                -1
              )}`
            ),
        })
      );

      setRendaMinimaMensal(parseFloat(responseSaqueAVista.VrUpf1) * 0.1);
      setPercentualMaximo(responsePorcentagem.slice(-1));
      setLoading(false);
    };

    recuperaInformacoesIniciais();
  }, [matricula, plano]);

  return !loading ? (
    <>
      <Helmet>
        <title>Forluz - Saque à vista</title>
      </Helmet>
      <h1 className="fw-bold page-title mb-2">Saque à vista</h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          {apiSaqueAVista.SolictStatusSol === 'pago' && (
            <InformacoesGerais apiSaqueAVista={apiSaqueAVista} />
          )}
          {apiSaqueAVista.CdConsistencia !== 2 &&
            apiSaqueAVista.SolictStatusSol !== 'pago' && (
              <InformacoesGerais apiSaqueAVista={apiSaqueAVista} />
            )}
          {apiSaqueAVista.CdConsistencia === 1 &&
            apiSaqueAVista.SolictStatusSol !== 'pago' && (
              <div className="row">
                <Formik
                  enableReinitialize
                  initialValues={{
                    percentualSaqueAVista: 0,
                    valorRendaMensalAposSaque: 0,
                    saldoRemanescente: 0,
                    valorSaqueAVista: 0,
                  }}
                  validationSchema={rendaSchema}
                  onSubmit={async (values, { setSubmitting }) => {
                    const saqueAVistaService = new SaqueAVistaService();
                    const params = {
                      InpCdPln: apiSaqueAVista.CdPln,
                      InpCdTpBnf: apiSaqueAVista.CdTpBnf,
                      InpNrIdentFunc: apiSaqueAVista.NrIdentFunc,
                      InpNrIdentBnf: apiSaqueAVista.NrIdentBnf,
                      InpCdTitGf: apiSaqueAVista.CdTitGf,
                      InpPercSaque: values.percentualSaqueAVista,
                      InpCdFrmRec: apiSaqueAVista.CdFrmRec,
                    };
                    const alteracaoPercentual =
                      await saqueAVistaService.setValorSaqueAVista(params);

                    setModalIsOpen(true);
                    setStatusRegistro(
                      alteracaoPercentual.RegistrarOperacaoSaqueaVistaResult
                    );
                    setSubmitting(false);
                  }}
                >
                  {({ handleSubmit, isSubmitting, isValid, values }) => {
                    const valorSaqueAVista =
                      apiSaqueAVista.VrSldReman *
                      (values.percentualSaqueAVista / 100);
                    const valorSaldoRemanescente =
                      apiSaqueAVista.VrSldReman - valorSaqueAVista;
                    const valorRendaMesalAposSaque =
                      valorSaldoRemanescente * (percentualRenda / 100);

                    return (
                      <form onSubmit={handleSubmit}>
                        <hr className="mt-2" />
                        <div className="row mt-32">
                          <div className="col-12 col-md-6">
                            <Field
                              name="percentualSaqueAVista"
                              component={TextInput}
                              type="number"
                              label="Percentual de Saque À Vista"
                            />
                            <h2 className="text-orange fw-bold ts-14">
                              Percentual máximo de {percentualMaximo}%
                            </h2>
                          </div>
                          <div className="col-12 col-md-6">
                            <Field
                              name="valorRendaMensalAposSaque"
                              disabled
                              value={currency(valorRendaMesalAposSaque)}
                              component={TextInput}
                              label="Valor da Renda Mensal Após o Saque"
                            />
                            {parseFloat(valorRendaMesalAposSaque) <
                              parseFloat(rendaMinimaMensal) && (
                              <p
                                className="text-red ts-12"
                                style={{ marginTop: '-15px' }}
                              >
                                O valor da renda resultante é menor que o valor
                                mínimo
                              </p>
                            )}
                            <h2 className="text-orange fw-bold ts-14">
                              A renda mensal mínima deve ser acima de
                              {` ${currency(rendaMinimaMensal)}`}
                            </h2>
                          </div>
                        </div>

                        <div className="row mt-32">
                          <div className="col-12 col-md-6">
                            <Field
                              name="saldoRemanescente"
                              className="mb-3"
                              value={currency(valorSaldoRemanescente)}
                              disabled
                              component={TextInput}
                              label="Saldo Remanescente Após Saque"
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <Field
                              name="valorSaqueAVista"
                              className="mb-3"
                              value={currency(valorSaqueAVista)}
                              disabled
                              component={TextInput}
                              label="Valor do Saque À Vista"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 col-md-6" />
                          <div className="col-12 col-md-6">
                            <div className="ms-auto col-6">
                              <Button
                                type="submit"
                                disabled={
                                  isSubmitting ||
                                  !isValid ||
                                  !(
                                    parseFloat(valorRendaMesalAposSaque) >=
                                    parseFloat(rendaMinimaMensal)
                                  )
                                }
                              >
                                Solicitar
                              </Button>
                            </div>
                          </div>
                        </div>
                      </form>
                    );
                  }}
                </Formik>
              </div>
            )}
          {apiSaqueAVista.CdConsistencia === 2 &&
            apiSaqueAVista.SolictStatusSol !== 'pago' && (
              <>
                <div className="row">
                  <div className="d-flex justify-content-center">
                    <h2 className="fw-bold mb-2 ts-26">
                      Resumo da solicitação
                    </h2>
                  </div>
                  <hr className="mb-32 mt-2" />
                  <div className="col-12 col-md-8 col-lg-4">
                    <h4 className="ts-20 fw-bold  mb-2 text-orange">
                      Percentual
                    </h4>
                    <h1 className="ts-18 fw-bold text-muted mb-3">
                      {`${apiSaqueAVista.SolictPercSaq}%`}
                    </h1>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <h4 className="ts-20 fw-bold  mb-2 text-orange">
                      Benefício pós saque
                    </h4>
                    <h1 className="ts-18 fw-bold text-muted mb-3">
                      {currency(
                        apiSaqueAVista.VrSldReman *
                          (apiSaqueAVista.PercRenda / 100)
                      )}
                    </h1>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <h4 className="ts-20 fw-bold  mb-2 text-orange">
                      Data da Solicitação
                    </h4>
                    <h1 className="ts-18 fw-bold text-muted mb-3">
                      {apiSaqueAVista.SolictDtSol !== undefined &&
                        `${apiSaqueAVista.SolictDtSol.substring(
                          6,
                          8
                        )}/${apiSaqueAVista.SolictDtSol.substring(
                          4,
                          6
                        )}/${apiSaqueAVista.SolictDtSol.substring(0, 4)}`}
                    </h1>
                  </div>
                </div>
                <div className="row mt-3 ">
                  <div className="col-12 col-md-8 col-lg-4">
                    <h4 className="ts-20 fw-bold  mb-2 text-orange">
                      Valor do saque
                    </h4>
                    <h1 className="ts-18 fw-bold text-muted mb-3">
                      {currency(apiSaqueAVista.SolictVrSaq)}
                    </h1>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <h4 className="ts-20 fw-bold  mb-2 text-orange">
                      Saldo pós saque
                    </h4>
                    <h1 className="ts-18 fw-bold text-muted mb-3">
                      {currency(apiSaqueAVista.VrSldReman)}
                    </h1>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <h4 className="ts-20 fw-bold  mb-2 text-orange">Status</h4>
                    <h1 className="ts-18 fw-bold text-muted mb-3">
                      {apiSaqueAVista.SolictStatusSol}
                    </h1>
                  </div>
                </div>
              </>
            )}
        </div>
      </div>
      <FModal isOpen={modalIsOpen} close onClose={() => setModalIsOpen(false)}>
        {!statusRegistro.Value ? (
          <>
            <Icons
              path={mdiCheckCircleOutline}
              color="var(--success)"
              size={2}
            />
            <h1 className="ts-20 fw-bold mb-1">Dados atualizados</h1>
            <p className="ts-16">Seu registro de saque à vista foi criado</p>
          </>
        ) : (
          <>
            <Icons path={mdiAlertCircleOutline} color="var(--error)" size={2} />
            <h1 className="ts-20 fw-bold mb-1">Ocorreu um erro</h1>
            <p className="ts-16">{statusRegistro.Value}</p>
          </>
        )}
      </FModal>
    </>
  ) : (
    <LoadingIndicator />
  );
};
